import { useState } from "react";
import { CloseIcon } from "asset/icons";
import { Bars } from "react-loader-spinner";
import Input from "component/form/Input";
import currencyPairCheck from "utilities/currencyPairCheck";
import { formatMoney } from "utilities/formatMoney";
import OTPInput from "component/form/OTPInput";

const MakePaymentModal = ({ currency, wallets, orderId, close }) => {
    const [step, setStep] = useState(0);
    const [otp, setOTP] = useState("");
    const [loading, setLoading] = useState(false);
    const [amount, setAmount] = useState("");

    const currentBalance = wallets?.find(({ currency: curr }) => curr === currency) || {
        balance: 100000,
    };

    const makePayment = () => {
        setLoading(true);

        setTimeout(() => {
            console.log(
                `Payment of ${formatMoney(amount)} in ${currency} made for Order ${orderId}`
            );
            setLoading(false);
            close();
        }, 2000);
    };

    return (
        <div
            className="fixed left-0 top-0 h-screen w-screen bg-[#1D29394D] z-[5000] grid place-items-center cursor-auto"
            onClick={(evt) => evt.stopPropagation()}
        >
            <div className="bg-page-bg rounded-2xl w-[95%] sm:w-[560px] !pt-1">
                <h3 className="flex justify-between text-main-dark font-semibold text-[23px] !px-6 !py-4 -mb-1.5">
                    {step ? "Confirm" : "Make a"} payment
                    <CloseIcon
                        className={`size-6 cursor-pointer translate-x-1 ${
                            loading && "pointer-events-none *:stroke-main-grey/60"
                        }`}
                        onClick={close}
                    />
                </h3>
                <p className="text-[#6B7280] !px-6 font-[380]">
                    {step
                        ? "Enter your PIN to confirm this payment"
                        : "Pay for this purchase order from your Tradevu account"}
                </p>

                {step ? (
                    <div className="!px-6 mt-9 mb-[25px]">
                        <OTPInput otp={otp} setOTP={setOTP} />
                    </div>
                ) : (
                    <>
                        <div className="flex items-end !gap-2 !px-6 !mt-7">
                            <div className="basis-[150px] *:first-of-type:pointer-events-none">
                                <Input
                                    placeholder="NGN"
                                    value={currency}
                                    require={false}
                                    label="Amount to pay"
                                    labelClassName="!text-[#667085] !mb-1"
                                />
                            </div>

                            <Input
                                onChange={(e) => setAmount(e.target.value)}
                                type="number"
                                value={amount}
                                placeholder="3,000,000"
                                formatType="integer"
                            />
                        </div>
                        <p className="!px-6 !mt-1.5 font-normal text-[13px] text-main-grey">
                            Current balance:
                            <span className="font-[450] ml-1.5">
                                {currencyPairCheck(currency)} {formatMoney(currentBalance?.balance)}
                            </span>
                        </p>
                    </>
                )}

                <div className="flex justify-end items-center !gap-6 !border-t !border-[#E7E9FB] !py-[18px] !px-6 mt-[21px]">
                    {!!step && (
                        <span
                            className="cursor-pointer text-main-dark/85"
                            onClick={() => setStep(0)}
                        >
                            Go back
                        </span>
                    )}
                    <button
                        className={`bg-[#6F00FF] rounded-lg h-10  ${
                            step ? "w-[101px]" : "w-[154px]"
                        } text-[#FBFAFF] font-[450] disabled:bg-secondary/30`}
                        disabled={(step ? otp.length !== 4 : !amount) || loading}
                        onClick={() => (step ? makePayment() : setStep(1))}
                    >
                        {loading ? (
                            <Bars
                                color="#fff"
                                height={23}
                                width={23}
                                wrapperClass="w-max mx-auto"
                            />
                        ) : step ? (
                            "Submit"
                        ) : (
                            "Make payment"
                        )}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default MakePaymentModal;
